import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { DescargasService } from '../../services/descargas/createTokenRequest.service';

@Component({
  selector: 'app-modal-validar-documento',
  templateUrl: './modal-validar-documento.component.html',
  styleUrls: ['./modal-validar-documento.component.css']
})
export class ModalValidarDocumentoComponent {
  loading = false;
  errorMsg = '';

  form = this.fb.group({
    documento: ['', [Validators.required, Validators.minLength(5)]],
  });

  constructor(
    private fb: FormBuilder,
    private descargasService: DescargasService,
    public dialogRef: MatDialogRef<ModalValidarDocumentoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { token: string, tipoCertificado: string }
  ) { }

  async descargar() {
    this.errorMsg = '';
    const documento = (this.form.value.documento || '').trim();
    if (this.form.invalid) return;

    try {
        this.loading = true;

        // Opción A: Usar navegación directa (Solución para WhatsApp)
        // Esto usará el GET que definimos en el Back y los headers forzarán la descarga
        this.descargasService.descargarDirectoGet(this.data.token, documento);

        // Cerramos el modal después de un momento
        setTimeout(() => {
            this.dialogRef.close(true);
            this.loading = false;
        }, 1000);

    } catch (e: any) {
        this.errorMsg = 'Error al procesar la descarga.';
        this.loading = false;
    }
  }

  cerrar() {
    this.dialogRef.close(false);
  }
}